// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"45":"wheel","743":"timer","800":"dataset","991":"prediction"}[chunkId] + "." + {"45":"41faaeec","743":"d4e47954","800":"c7b49a99","991":"4167dce2"}[chunkId] + ".css";
};